import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Pipers from '../../../components/Pipers/Pipers';
import PiperTip from '../../../components/PiperTips/PiperTip';
import GlobalTheme from '../../../styled/GlobalTheme';

const PiperContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  /* margin-top: 5rem; */
  ${GlobalTheme.breakpoints.down('xs')}{
    margin-top: 0px;
  }
`;

// TODO add next styles to the main PiperTip in the position="top" form
const PiperTipTop = styled(PiperTip)`
  .piper-wrapper{
    padding-right: 70px;
  }
`;

const PiperTipRight = styled(PiperTip)`
  grid-template-columns: auto 200px;
  padding-top: 50px;
  justify-content: center;
  width: 100%;
  grid-gap: 32px;
  .tip{
    margin-top:-31px;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    grid-gap: 16px;
    grid-template-columns: 100px minmax(178px, 1fr);
    .tip{
      margin-top: -50px;
    }
  }
`;

const PiperTipTablet = styled(PiperTip)`
  grid-template-columns: 125px 450px;
  justify-content: center;
  width: 100%;
  grid-gap: 32px;
  .tip{
    margin-top:-31px;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    grid-gap: 16px;
    grid-template-columns: 100px minmax(178px, 1fr);
    .tip{
      margin-top: -50px;
    }
  }
`;

export default function PiperPresentation({ position }) {
  if (position === 'top') {
    return (
      <PiperContainer>
        <PiperTipTop Piper={Pipers.Piper2} position={position}>
          <FormattedMessage
            id="onboarding.piperPresentation.piperTip"
            defaultMessage="Hi I’m Piper, your trusty social media guide. I’ll be at your side with insights and advice, every step of the way should you need it."
          />
        </PiperTipTop>
      </PiperContainer>
    );
  }
  if (position === 'right') {
    return (
      <PiperContainer>
        <PiperTipTablet Piper={Pipers.Piper2} position={position} trianglePosition="right">
          <FormattedMessage
            id="onboarding.piperPresentation.piperTip"
            defaultMessage="Hi I’m Piper, your trusty social media guide. I’ll be at your side with insights and advice, every step of the way should you need it."
          />
        </PiperTipTablet>
      </PiperContainer>
    );
  }
  return (
    <PiperContainer>
      <PiperTipRight Piper={Pipers.Piper2} position={position} trianglePosition="bottom">
        <FormattedMessage
          id="onboarding.piperPresentation.piperTip"
          defaultMessage="Hi, I’m Piper, your expert social media guide. I’ll be at your side with insights and advice, every step of the way should you need it."
        />
      </PiperTipRight>
    </PiperContainer>
  );
}

PiperPresentation.propTypes = {
  position: PropTypes.string,
};

PiperPresentation.defaultProps = {
  position: 'right',
};
